import React from 'react';
import LeftSidebar from '../components/navigation/LeftSidebar';
import Footer from '../components/Footer';

interface DesktopShellProps {
  children: React.ReactNode;
}

export default function DesktopShell({ children }: DesktopShellProps) {
  return (
    <div className="hidden lg:flex min-h-screen bg-bg pt-16 overflow-hidden">
      <LeftSidebar />
      <div className="flex-1 ml-[280px] flex flex-col min-w-0 overflow-hidden">
        <main className="flex-1 overflow-y-auto overflow-x-hidden min-w-0">
          {children}
          <Footer />
        </main>
      </div>
    </div>
  );
}

